export default __webpack_public_path__ + "static/media/illustration_financial-data_inactive.861c5491.png";